export const backgroundColor = '#F1F2F4';
export const textColor = '#1d1d1b';
export const lightTextColor = '#505050';
export const secondaryColor = '#FF7149';
export const gray = '#c4c4c4';
export const darkGray = '#616161';
export const black = '#0000000';

export const blogCategoryColors: { [index: string]: string } = {
    orange: secondaryColor,
    yellow: '#f5a56e',
    purple: '#c2559b',
    lightOrange: '#fed448',
    blue: '#4ca9df',
};
export const white = '#ffffff';
export const darkGrey = '#e9e9e9';
export const notificationReadColor = '#c4c4c4';
export const notificationCaptionColor = '#acacac';
export const resultColors = {
    green: '#70bf73',
    yellow: '#ffc107',
    red: '#f44336',
    lightGreen: '#C8E6C9',
    lightYellow: '#FFE79E',
    lightRed: '#FFCDD2',
};
